// dependencies
import React, { useState } from "react";

import { faPlus, faSearch } from "@fortawesome/pro-regular-svg-icons";

// components
import { AdminTitle } from "../../../../../../components/Admin";
import Button from "../../../../../../components/Button";
import TextInput from "../../../../../../components/Inputs/InputText";
import Spacer from "../../../../../../components/Spacer";
import Directory from "./Directory";

// hooks
import useDebouncedValue from "../../../../../../hooks/useDebouncedValue";

interface MainProps {
	setPage: (page: string) => void;
	excludedUsers: string[];
	selectionObjectID: string;
}

const Main = (props: MainProps) => {
	const { setPage, excludedUsers, selectionObjectID } = props;

	const [search, setSearch] = useState("");
	const debouncedSearch = useDebouncedValue(search, 250);

	return (
		<>
			<AdminTitle description="Add employees to be excluded from future pulse surveys.">
				Excluded Employees
			</AdminTitle>
			<Spacer height={3} />
			<div>
				<div className="flex justify-between">
					<TextInput
						value={search}
						onChange={setSearch}
						placeholder="Search employees..."
						icon={faSearch}
						clearable
						className="w-[288px]"
					/>

					<Button
						color="blue"
						icon={faPlus}
						iconPosition="left"
						onClick={() => {
							setPage("add-employees");
						}}
					>
						Exclude Employees
					</Button>
				</div>
				<Spacer height={2} />
				<Directory
					selectedEmployees={excludedUsers}
					setSelectedEmployees={() => {}}
					employeeSearchProps={{
						searchTerm: debouncedSearch,
						userSelectionID: selectionObjectID,
						limitSelected: true,
					}}
					canSingleDelete={true}
					emptyText={
						debouncedSearch
							? "A search on the employee list results in no matches."
							: "There are currently no excluded employees."
					}
				/>
			</div>
		</>
	);
};

export default Main;
